import React from 'react';
import { XSBox, XSBoxInput } from '../box/XSBox';
import clsx from 'clsx';
import './XSLayer.css';

export type XSLayerInput = XSBoxInput & {
    shape?: 'round' | 'square';
};

export function XSLayer(input: XSLayerInput) {
    const { className, shape, ...rest } = input;
    return <XSBox {...rest} className={clsx(className, `XSLayer shape-${shape}`)} />;
}
